var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import cx from 'classnames';
import Text, { TextSize } from '@move-ui/text';
import styles from './Label.module.css';
export var Label = function (_a) {
    var _b;
    var className = _a.className, children = _a.children, htmlFor = _a.htmlFor, id = _a.id, isScreenReaderOnly = _a.isScreenReaderOnly, _c = _a.applyDisabledStyle, applyDisabledStyle = _c === void 0 ? false : _c, preactFor = _a.preactFor, _d = _a.errorMessage, errorMessage = _d === void 0 ? '' : _d, showError = _a.showError;
    return (
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    React.createElement("label", __assign({ className: cx((_b = {}, _b[styles.screenReaderOnly] = isScreenReaderOnly, _b), className) }, (preactFor ? { for: htmlFor } : { htmlFor: htmlFor }), { id: id }),
        React.createElement(Text, { size: TextSize.XS, color: applyDisabledStyle ? 'neutral-300' : 'neutral-100', bold: true }, children),
        showError && (React.createElement("span", { className: styles.hideErrorMessage }, errorMessage))));
};
//# sourceMappingURL=Label.js.map